module.exports = __webpack_public_path__ + "static/media/nube.9a3fb438.svg";